module.exports = __webpack_public_path__ + "static/media/folder.7676c05f.svg";